/*  ==========================================================================
    PRICE OVERVIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';
import Stickyfill from 'stickyfilljs';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import objectFitImages from "object-fit-images";

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {
}

// custom function
function funcCustom(container,data) {

    // create sticky seasondatas
    let $stickyPriceServiceContainer = $(container).find('.bn-room-rates').first();
    $stickyPriceServiceContainer.clone().insertBefore($stickyPriceServiceContainer).addClass('bn-room-rates--sticky');

    // position sticky polyfill for older browser
    let stickyElement = $(container).find('.bn-room-rates.bn-room-rates--sticky');
    Stickyfill.add(stickyElement);

    // create price lists (if containers are in view)
    $(container).find('.eh-rates').each(function () {
        let priceServiceContainer = $(this);
        $(priceServiceContainer).one('inview', function() {
            utils.ehotelierPrices.initEhotelierRoomPriceList(priceServiceContainer);
        });
    });

}

// initialization
export function initPriceOverview($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'room',
        subtype: 'price-overview'
    };

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/price-overview.js